import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import {
  selectEditedUserErrors,
  selectSignupProcessPending,
} from '../../../redux/profiles/selectors';
import {
  selectSignupPersonalInfoFormData,
  selectSignupProcessFormData,
} from '../../../redux/auth/signup/selectors';
import { selectRequestPasswordUpdate } from '../../../redux/auth/selectors';
import {
  selectCountryList,
  selectEthnicTypes,
  selectGenderTypes,
  selectNameSuffixesList,
  selectRaceTypes,
} from '../../../redux/data/selectors';
import { signupActions } from '../../../redux/auth/signup/actions';
import { loggedUserSelector } from '../../../redux/context/selectors';
import { getSelectOptions } from '../../ProfileLayout/utils/getSelectOptions';
import { changePasswordActions } from '../../../redux/auth/changePassword/actions';
import { selectChangePasswordProcessFormData } from '../../../redux/auth/changePassword/selectors';
import checkCountryForOrganization from '../../../utils/handleUserData/checkCountryForOrganization';
import parseJSONSafely from '../../../utils/parseJSONSafely';
import { convertGenderList } from '../../../utils/converters/convertListWithLocalization';
import styles from '../index.styl';

const mapStateToProps = state => ({
  nameSuffixList: selectNameSuffixesList(state),
  profile: loggedUserSelector(state),
  dataValidationErrors: selectEditedUserErrors(state),
  profileEditable: parseJSONSafely(localStorage.getItem('fieldsEditable')),
  personalInfoData: selectSignupPersonalInfoFormData(state),
  signupData: selectSignupProcessFormData(state),
  changePasswordData: selectChangePasswordProcessFormData(state),
  isPasswordUpdate: selectRequestPasswordUpdate(state),
  countriesList: selectCountryList(state),
  pendingProcess: selectSignupProcessPending(state),
  rawGenderList: selectGenderTypes(state),
  races: selectRaceTypes(state),
  ethnicitys: selectEthnicTypes(state),
});

const mapDispatchToProps = {
  confirmSignUp: signupActions.confirm,
  confirmChangePassword: changePasswordActions.confirm,
  personalInfoChange: signupActions.personalInfoChange,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      intl: { formatMessage },
      signupData,
      confirmSignUp,
      changePasswordData,
      confirmChangePassword,
      profile,
      isPasswordUpdate,
      countriesList,
      rawGenderList,
      races,
      ethnicitys,
    }) => {
      const { id, userOrganizations } = profile || {};

      return {
        confirm: isPasswordUpdate ? confirmChangePassword : confirmSignUp,
        firstStepData: signupData || changePasswordData,
        userId: id,
        formatMessage,
        isPasswordUpdate,
        title: 'titles.signup',
        countries: getSelectOptions(
          countriesList.map(country => country && country.name),
        ),
        genderList: convertGenderList(rawGenderList, formatMessage) || [],
        countryForOrganization: checkCountryForOrganization(userOrganizations),
        races,
        ethnicitys,
      };
    },
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Auth/AuthPersonalInfo/enhance.js